module.exports = __webpack_public_path__ + "img/5.ffb0ee78.jpg";